import PropTypes from 'prop-types';
import { useRef } from 'react';
import styled from 'styled-components';
import { Link } from 'components/common/link';
import { useRouteMatch } from 'react-router-dom';
import { color } from 'constants/styled-theme';

const CleanLink = ({ isMatch, ...rest }) => <Link {...rest} />;

CleanLink.propTypes = {
  isMatch: PropTypes.bool,
  onClick: PropTypes.func
};

const TabWrapper = styled.div`
  min-width: 90px;
  height: 50px;
  display: ${p => (p.isHide ? 'none' : 'flex')};
`;
const StyledLink = styled(CleanLink)`
  position: relative;
  height: 100%;
  padding: 0 10px;
  text-align: center;
  text-transform: uppercase;
  font-size: 18px;
  font-family: ${props => props.theme.fonts.regular};
  line-height: 17px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${prop =>
    prop.isMatch || prop.selected ? color('activeMenuColor') : color('menuFontColor')};
  &:hover .hover-line {
    opacity: 1;
  }
  @media (max-width: ${p => p.theme.mobile}) {
    font-size: 11px;
    line-height: 12px;
  }

  @media (min-width: 1024px) and (max-width: 1300px) {
    font-size: 13px;
    padding: 0 6px;
  }
`;
const HoverLine = styled.div`
  background: ${prop =>
    prop.isMatch || prop.selected ? color('activeMenuColor') : color('mainMenuHoverLine')};
  position: absolute;
  width: 100%;
  height: 2px;
  bottom: 10px;
  opacity: ${prop => (prop.isMatch || prop.selected ? '100' : '0')};
  transition: 0.5s;
`;

const Tab = ({ to, children, onClick, isHide, selected, onMouseEnter }) => {
  const ref = useRef(null);
  const isMatch = !!useRouteMatch(to);
  // useEffect(() => {
  //   if (isMatch) onClick(ref);
  // }, []);
  return (
    <TabWrapper
      ref={ref}
      onClick={() => (onClick ? onClick(ref) : null)}
      isHide={isHide}
      onMouseEnter={onMouseEnter}
    >
      <StyledLink {...{ to, isMatch, selected }}>
        {children}
        <HoverLine className="hover-line" isMatch={isMatch} selected={selected} />
      </StyledLink>
    </TabWrapper>
  );
};

Tab.propTypes = {
  to: PropTypes.string,
  children: PropTypes.node,
  onClick: PropTypes.func,
  onMouseEnter: PropTypes.func,
  isHide: PropTypes.bool,
  selected: PropTypes.bool
};

export default Tab;
